
export const indicatorTableColumns = [
  {
    field: "objectiveIndicator",
    header: "Objetivo del Indicador",
    columnWidth: "160px",
    columnType: "tooltip"
  },
  {
    field: "responsible",
    header: "Responsable",
    columnWidth: "160px"
  },
  {
    field: "indicator",
    header: "Indicador",
    columnWidth: "160px"
  },
  {
    field: "indexData",
    header: "Indice",
    columnWidth: "160px",
    columnType: "tooltip"
  },
  {
    field: "goal",
    header: "Meta",
    columnWidth: "160px"
  },
  {
    field: "rangeData",
    header: "Rango",
    columnWidth: "160px"
  }
];

/** Columnas tabla Accesorios (biomedicalEquipmentBase y equipementResumeSection) - API getCallAccessoryData → table */
export const accesoriesColumns = [
  { field: "accessory", header: "Accesorio" },
  { field: "partNumberAccessory", header: "Número de parte" },
  { field: "quantity", header: "Cantidad" }
];

/** Alias: mismas columnas que accesoriesColumns para la sección de accesorios del resumen */
export const biomedicalAccesoriesColumns = accesoriesColumns;

/** Columnas tabla Características Técnicas - API getCallResumeFeatureData → table */
export const technicalFeaturesColumns = [
  { field: "featureName", header: "Característica" },
  { field: "description", header: "Descripción" }
];
